import { TEAM_USER_ROLES } from "common/constants";

export const isOwnerOrLibrarian = role => {
    return (
        role === TEAM_USER_ROLES.OWNER ||
        role === TEAM_USER_ROLES.LIBRARIAN
    );
};
